<div class="header-container" fxFlex fxLayout="column" [ngClass]="routeClassName">
    <mat-toolbar class="header-toolbar">
        <!--
        <button mat-icon-button (click)="openMenuMobile()">
            <mat-icon fontSet="phr-iconset" class="phr-iconset-menu icon" color="primary"></mat-icon>
        </button>
        -->
        <img src="/assets/images/town-center/logo-blanco.png"/>

        <!-- Anonymous Menu -->
        <app-anonymous-menu *ngIf="!loading && isLicensedCompany"></app-anonymous-menu>

        <!-- Unlicensed Menu -->
        <app-unlicensed-menu *ngIf="!loading && !isLicensedCompany"></app-unlicensed-menu>

    </mat-toolbar>
</div>
<!--
<div class="header-desktop-container" fxHide.lt-lg>
    <app-anonymous-menu></app-anonymous-menu>
</div>
-->
